module.exports = __webpack_public_path__ + "static/media/outdoor-ed.8c612779.jpg";